angular.module('dnecom')
    .controller('StoreModalController', ["$scope", "$uibModalInstance", "$http", "StoreUtils", "store", "IntegrationsUtils", function($scope, $uibModalInstance, $http, StoreUtils, store, IntegrationsUtils) {
        const AccountsGroupEnum = {
            'aweber': 'AWeber',
            'getresponse': 'GetResponse',
            'google': 'Google',
            'braintree': 'Credit Cards',
            'paypal': 'PayPal',
            'paypal_express': 'PayPal',
            'stripe': 'Credit Cards',
            'paystack': 'Credit Cards',
            'fondy': 'Credit Cards',
            'payfast': 'Credit Cards',
            'mailchimp': 'MailChimp',
            'facebookpixel': 'FacebookPixel',
            'sendlane':'Sendlane',
            'sendgrid':'Sendgrid',
            'activecampaign': 'ActiveCampaign',
            'convertkit': 'ConvertKit',
            'mcafee': 'McAfee',
            'cod': 'Cash on delivery',
            'pod': 'Payment on delivery',
            'pop': 'Payment on pickup',
        };
        const AccountsTypesEnum = {
            'aweber': 'AWeber',
            'getresponse': 'GetResponse',
            'google': 'Google',
            'braintree': 'Braintree',
            'paypal': 'PayPal',
            'paypal_express': 'PayPal Express',
            'stripe': 'Stripe',
            'paystack': 'Paystack',
            'fondy': 'Fondy',
            'payfast': 'Payfast',
            'mailchimp': 'MailChimp',
            'facebookpixel': 'FacebookPixel',
            'sendlane':'Sendlane',
            'sendgrid':'Sendgrid',
            'activecampaign': 'ActiveCampaign',
            'convertkit': 'ConvertKit',
            'mcafee': 'McAfee',
            'cod': 'Cash on delivery',
            'pod': 'Payment on delivery',
            'pop': 'Payment on pickup',
        };

        $scope.edit = Object.keys(store).length ? true : false;
        $scope.store = angular.copy(store.store || store);
        $scope.newStore = store.newStore || null;
        $scope.inputInvalid = false;
        $scope.step = 1;
        $scope.allSteps = 3;
        $scope.uploaded = false;
        $scope.autoresponderList = [];
        $scope.selectedAutoresponderType = false;
        $scope.autoresponderListsLoading = false;
        $scope.activePaymentTypes = TemplateData.value('activePaymentTypes');
        $scope.currencies = TemplateData.value('currenies');
        $scope.selectedCurrency = null;
        $scope.unavailableMerchants = [];
        $scope.store.paymentMethods = [];

        $scope.accounts = [];
        $scope.fetchedAccounts = [];
        $scope.noAccounts = true;

        $scope.loadAccounts = function(callback) {
            IntegrationsUtils.getAccountsByTypes(function(accounts) {
                $scope.accounts = accounts;
                $scope.fetchedAccounts = accounts;
                $scope.noAccounts = _.isEmpty($scope.accounts);

                if (callback) {
                    callback();
                }
            });
        };

        $scope.loadAccounts();

        $scope.$on('integration.account.saved', function() {
            $scope.loadAccounts(function() {
                var accounts = $scope.fetchAccounts($scope.activePaymentTypes);

                if (accounts && accounts[0]) {
                    $scope.addNewPaymentMethod(accounts[0]);
                }
            });
        });

        if (!$scope.store.properties) {
            $scope.store.properties = {};
        }

        if (!$scope.store.timezone) {
            $scope.store.timezone = 'UTC';
        }

        $scope.validateForm = function(form) {
            if (form.$invalid || form.$pending) {
                form.$setTouched();

                $scope.scrollToTop();

                return false;
            }

            return true;
        };

        $scope.selectCurrency = function () {
            $scope.activePaymentTypes = TemplateData.value('activePaymentTypes');
            $scope.accounts = $scope.fetchedAccounts;
            if ($scope.store.currency) {
                $scope.unavailableMerchants = [];
                $scope.selectedCurrency = $scope.currencies.find(function (item) {
                    return item.code === $scope.store.currency;
                })

                if ($scope.selectedCurrency) {
                    if (!$scope.selectedCurrency.isSupportedByPayPal) {
                        $scope.activePaymentTypes.indexOf('paypal') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('paypal'), 1);
                        $scope.activePaymentTypes.indexOf('paypal_express') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('paypal_express'), 1);
                        $scope.unavailableMerchants.push('PayPal');
                    }
                    if (!$scope.selectedCurrency.isSupportedByStripe) {
                        $scope.activePaymentTypes.indexOf('stripe') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('stripe'), 1);
                        $scope.unavailableMerchants.push('Stripe');
                    }
                    if (!$scope.selectedCurrency.isSupportedByBraintree) {
                        $scope.activePaymentTypes.indexOf('braintree') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('braintree'), 1);
                        $scope.unavailableMerchants.push('Braintree');
                    }
                    if (!$scope.selectedCurrency.isSupportedByFondy) {
                        $scope.activePaymentTypes.indexOf('fondy') > -1 && $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('fondy'), 1);
                        $scope.unavailableMerchants.push('Fondy');
                    }

                    if ($scope.activePaymentTypes.indexOf('paystack') > -1 && $scope.accounts.paystack) {
                        let acceptedAccounts = [];
                        $scope.accounts.paystack.forEach(function (account) {
                            if (account.properties.currency && account.properties.currency === $scope.selectedCurrency.code) {
                                acceptedAccounts.push(account);
                            }
                        });
                        if (!acceptedAccounts.length) {
                            $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('paystack'), 1);
                        } else {
                            $scope.accounts.paystack = acceptedAccounts;
                        }
                    }

                    if (
                        $scope.activePaymentTypes.indexOf('payfast') > -1
                        && (!$scope.selectedCurrency.code || $scope.selectedCurrency.code.toLowerCase() != 'zar')
                    ) {
                        $scope.activePaymentTypes.splice($scope.activePaymentTypes.indexOf('payfast'), 1);
                    }
                }
            }
        }

        $scope.getUnavailableMerchantsString = function () {
            return $scope.unavailableMerchants.join(', ');
        }

        $scope.scrollToTop = function() {
            $('.wizard-fixed .modal-body').scrollTop(0);
        };

        $scope.prev = function(form) {
            if ($scope.step > 1) {
                $scope.moveToStep($scope.step - 1, form);
            }
        };

        $scope.next = function(form) {
            $scope.moveToStep($scope.step + 1, form);
        };

        $scope.moveToStep = function(step, form) {
            if (!$scope.validateForm(form)) {
                return;
            }

            $scope.step = step;

            $scope.scrollToTop();
        };

        $scope.save = function(form) {
            if (!$scope.validateForm(form)) {
                return;
            }

            $uibModalInstance.close($scope.store);
        };

        $scope.upload = function(file) {
            StoreUtils.upload($scope.store, file, function(media) {
                $scope.store.logo = media;
            });
        };

        $scope.uploadUrl = function(url) {
            StoreUtils.uploadUrl($scope.store, url, function(media) {
                $scope.store.logo = media;
            });
        };

        $scope.refreshAutoresponderList = function(accountId) {
            if (accountId) {
                $scope.autoresponderListsLoading = true;

                IntegrationsUtils.getAutoResponderList($scope.store.id, accountId, function (list) {
                    $scope.autoresponderLists = list.length > 0 ? list : [];
                    $scope.autoresponderListsLoading = false;
                }, function () {
                    $scope.autoresponderListsLoading = false;
                    $scope.store.properties.integrations.autoresponder = null;
                    $scope.store.properties.integrations.autoresponderListForAbandons = null;
                });

                $scope.selectedAutoresponderType = $scope.getAutoresponderType(accountId);
            } else {
                $scope.autoresponderLists = [];
            }
        };

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.normalizeAccountType = function(type) {
            return AccountsGroupEnum[type];
        };

        $scope.filterOutType = function(type) {
            return function(account) {
                return !(AccountsGroupEnum[account.type] === AccountsGroupEnum[type]
                    || (type === 'braintree' && AccountsGroupEnum[account.type] === 'PayPal')
                    || (AccountsGroupEnum[type] === 'PayPal' && account.type === 'braintree'));
            }
        };

        $scope.getAccountPrefix = function (account) {
            if (account && ['pop', 'pod'].includes(account.type) && $scope.store.paymentMethods.some(pm => pm && pm.accountId === account.id)) {
                return account.typeName + ' - ';
            }

            if (account && ['Credit Cards', 'PayPal'].includes(AccountsGroupEnum[account.type])) {
                return AccountsTypesEnum[account.type] + ' - ';
            }

            return '';
        }

        $scope.filterPaymentMethods = function (method) {
            if (method) {
                $scope.store.paymentMethods = $scope.store.paymentMethods.filter(function( obj ) {
                    return obj === method
                        || (obj && method.type !== 'braintree' && AccountsGroupEnum[obj.type] !== AccountsGroupEnum[method.type])
                        || (obj && method.type === 'braintree' && ['pod', 'pop'].includes(obj.type));
                });
            }
        };

        $scope.fetchAccounts = function(types) {
            return _.map(_.flatten(_.values(_.pick($scope.accounts, types))), function(account) {
                account.accountId = account.id;

                return account;
            });
        };

        $scope.addNewPaymentMethod = function(account) {
            if (!$scope.store.paymentMethods) {
                $scope.store.paymentMethods = [];
            }

            $scope.store.paymentMethods.push({
                accountId: account.id
            });
        };

        $scope.getAutoresponderType = function(accountId) {
            if (accountId && $scope.accounts) {
                for (var key in $scope.accounts) {
                    for (var j = 0; j < $scope.accounts[key].length; j++) {
                        if ($scope.accounts[key][j].id == accountId)
                            return $scope.accounts[key][j].type;
                    }
                }
            }

            return false;
        };

        if (!$scope.store.properties.pages && !$scope.store.id) {
            $scope.store.properties.pages = {};
            $scope.store.properties.pages.about = TemplateData.value('aboutDefaultTemplate');
            $scope.store.properties.pages.termsOfService = TemplateData.value('tosDefaultTemplate');
            $scope.store.properties.pages.privacyPolicy = TemplateData.value('ppDefaultTemplate');
            $scope.store.properties.pages.refundPolicy = TemplateData.value('rpDefaultTemplate');
            $scope.store.properties.pages.contactUs = TemplateData.value('contactUsDefaultTemplate');
        }
    }])

    .directive('validationDomain', ["$q", "$http", "$parse", function($q, $http, $parse) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelController) {
                var payload = $parse(attrs.validationDomain)(scope);

                ngModelController.$asyncValidators.validationDomain = function(modelValue, viewValue) {
                    if (ngModelController.$isEmpty(modelValue)) {
                        return $q.when(true);
                    }

                    var deffered = $q.defer();

                    payload[payload.type] = viewValue;

                    $http.post(Routing.generate('stores_check_domain'), payload)
                        .then(function(response) {
                            if (!response.data.success) {
                                deffered.reject();
                            } else {
                                deffered.resolve();
                            }
                        }, function() {
                            deffered.reject();
                        });

                    return deffered.promise;
                };
            }
        };
    }]);
